import { Component, OnInit } from '@angular/core';
import { IShadowUser } from '../../../models/request-and-responses/rest-api/interfaces/shadowUser';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../services/data.service';
import { PataviumRole } from '../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { HeaderService } from '../../../services/header.service';
import { SessionStorageService } from '../../../services/session-storage.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
    public currentUser: IShadowUser;
    public imgPreview;
    public currentRole: PataviumRole = SessionStorageService.sessionInfo.role;
    public avatarToUpload: File = null;

    constructor(
        protected toastr: ToastrService,
        protected api: DataService,
        private headerService: HeaderService
    ) {}

    ngOnInit() {
        this.initData();
    }

    initData() {
        this.api.whoAmI().subscribe(
            user => {
                this.currentUser = user.item.user;
            },
            err => {}
        );
        this.api.getAvatarCurrentUser().subscribe(avatar => {
            this.imgPreview = 'data:image/png;base64,' + avatar.payload[0].avatar;
        });
    }

    uploadFile(event: any) {
        if (event.target.files && event.target.files[0]) {
            this.avatarToUpload = event.target.files[0];
            const reader = new FileReader();
            reader.onload = (evt: any) => {
                this.imgPreview = evt.target.result;
                event.target.value = null;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    uploadAvatar() {
        const formData = new FormData();
        if (this.avatarToUpload !== null) {
            formData.append('avatarFile', this.avatarToUpload, this.avatarToUpload.name);
            formData.append('id', SessionStorageService.id.get());
            this.api.uploadAvatar(SessionStorageService.sessionInfo.userId, formData).subscribe(
                result => {
                    this.toastr.success('Avatar aggiornato correttamente', 'Successo');
                    this.avatarToUpload = null;
                    this.initData();
                    this.headerService.updateAvatarSubject().next();
                },
                err => {}
            );
        }
    }

    get roleLabel(): string {
        switch (this.currentRole) {
            case PataviumRole.Admin:
                return 'Admin';
            case PataviumRole.BackOfficeOperator:
                return 'Operatore';
            case PataviumRole.Agency:
                return 'Team';
            case PataviumRole.AgencyOperator:
                return 'Operatore/Team';
            case PataviumRole.Agent:
                return 'Venditore';
            default:
                return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/common/profile/profile.component.ts